import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import {
  SaveBKExportSettingsRequest,
  SaveBKExportSettingsResponse,
  GetBKExportSettingsRequest,
  GetBKExportSettingsResponse,
} from "../../models/BKExportSettings.model";

const API_BASE_URL = environment.apiUrl;

export const saveBKExportSettings = createAsyncThunk<
  SaveBKExportSettingsResponse,
  SaveBKExportSettingsRequest,
  { rejectValue: string }
>(
  "bkExportSettings/saveBKExportSettings",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}BKExportSettings/SaveBKExportSettings`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        },
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: SaveBKExportSettingsResponse = await response.json();

      if (!data.success)
        return rejectWithValue(data.message || 'שגיאה בשמירת הגדרות הנה"ח');
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error",
      );
    }
  },
);
export const getBKExportSettings = createAsyncThunk<
  GetBKExportSettingsResponse,
  GetBKExportSettingsRequest,
  { rejectValue: string }
>(
  "bkExportSettings/getBKExportSettings",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}BKExportSettings/GetBKExportSettings`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        },
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: GetBKExportSettingsResponse = await response.json();

      if (!data.success && !data.accountNo_Income && !data.customerSortCode)
        return rejectWithValue(data.message || 'שגיאה בקבלת הגדרות הנה"ח');
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error",
      );
    }
  },
);
